import React from 'react';
import { useTranslation } from 'react-i18next';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
const GoToTier = ({ deviation  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(ListItem, {
        label: t('deviationview.tierCard.moreActionsMenu.item.goToTierPage'),
        onClick: ()=>{
            window.location.href = deviation.url;
        }
    });
};
GoToTier.displayName = 'GoToTier';
export default GoToTier;
